<template>
    <SOSlotBase :bg-white="true" :container-name="'pengingat-masa-aktif'" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="'Pengingat Masa Aktif'" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-y-12">
                <div class="f-regular f-14 f-c-black">
                    Pengingat yang dikirimkan kepada konsumen saat masa aktif paket hampir kedaluwarsa.
                </div>
            </div>
            <div class="separator"></div>
            <div class="p-x-20 p-y-20 border-bottom">
                <SOInputOnOff
                    class="m-d-20"
                    :checkboxes="paketDeposit"
                    :checked="pageSetting.section.deposit"
                    @selected="onoffDeposit"
                    :disabled="!validateAccess(activePeriodReminderUpdate)"
                />

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.deposit">
                    Perangkat yang digunakan
                </div>
                <div @click="validateAccess(activePeriodReminderUpdate) && showModalPerangkat('deposit', reminderInfo.iddevice_reminder_deposit)">
                    <SOSlotCard
                        v-if="pageSetting.section.deposit"
                        :card-type="'box'"
                        :dropdown-menu="'none'"
                        class="p-d-8 m-d-16"
                    >
                        <template v-slot:card_head>
                            <div class="top-card">
                                <div class="f-regular f-16 f-c-black nomore" style="width: 250px">
                                    {{ deviceDeposit }}
                                </div>
                                <img src="@/assets/icon-sidebar/chevron-down.svg" alt="" />
                            </div>
                        </template>
                        <template v-slot:card_body>
                            <div class="f-regular f-14 f-c-midgrey">
                                {{ numberDeposit }}
                            </div>
                        </template>
                    </SOSlotCard>
                </div>

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.deposit">
                    Ingatkan pada
                </div>
                <div v-if="pageSetting.section.deposit">
                    <SOSlotCard
                        :card-type="'box'"
                        :dropdown-menu="'card'"
                        v-for="data in reminderInfo.data_reminder_deposit"
                        :key="data.id"
                        class="p-d-8"
                    >
                        <template v-slot:card_head>
                            <div class="top-card">
                                <div class="f-regular f-16 f-c-black">
                                    {{ reminderOption.filter((a) => a.id === data.idcountdown_master)[0].nama }}
                                </div>
                                <div class="card-menu-vertical"></div>
                            </div>
                        </template>
                        <template v-slot:card_body>
                            <div class="f-regular f-14 f-c-midgrey" v-if="data.sending_time !== null">
                                <!-- <span v-if="data.idcountdown_master !== 1">
                                    Dikirim pukul {{ data.sending_time.substr(0, 5) }} WIB
                                </span> -->
                            </div>
                        </template>
                        <template v-slot:menu_card>
                            <button class="dropdown-item icon-2" @click="validateAccess(activePeriodReminderUpdate) && showModal('deposit', 'edit', data.id)">
                                <span class="mar-right-10">
                                    <img src="@/assets/icons/edit_2.svg" />
                                </span>
                                Ubah
                            </button>
                            <button class="dropdown-item icon-2" @click="validateAccess(activePeriodReminderUpdate) && showDeleteModal('deposit', data.id)">
                                <span class="mar-right-10">
                                    <img src="@/assets/icons/trash-red.svg" />
                                </span>
                                Hapus
                            </button>
                        </template>
                    </SOSlotCard>
                </div>

                <div v-if="pageSetting.section.deposit" class="d-flex p-t-8" @click="validateAccess(activePeriodReminderUpdate) && showModal('deposit', 'create')">
                    <img src="@/assets/icons/plus-blue.svg" alt="" />
                    <div class="f-regular f-16 f-c-blue p-l-8">Tambah Pengingat</div>
                </div>
            </div>

            <div class="p-x-20 p-y-20 border-bottom">
                <SOInputOnOff
                    :disabled="!validateAccess(activePeriodReminderUpdate)"
                    class="m-d-20"
                    :checkboxes="paketEpayment"
                    :checked="pageSetting.section.epayment"
                    @selected="onoffEpayment"
                />

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.epayment">
                    Perangkat yang digunakan
                </div>
                <div @click="validateAccess(activePeriodReminderUpdate) && showModalPerangkat('emoney', reminderInfo.iddevice_reminder_emoney)">
                    <SOSlotCard
                        v-if="pageSetting.section.epayment"
                        :card-type="'box'"
                        :dropdown-menu="'none'"
                        class="p-d-8 m-d-16"
                    >
                        <template v-slot:card_head>
                            <div class="top-card">
                                <div class="f-regular f-16 f-c-black nomore" style="width: 250px">
                                    {{ deviceEpayment }}
                                </div>
                                <img src="@/assets/icon-sidebar/chevron-down.svg" alt="" />
                            </div>
                        </template>
                        <template v-slot:card_body>
                            <div class="f-regular f-14 f-c-midgrey">
                                {{ numberEpayment }}
                            </div>
                        </template>
                    </SOSlotCard>
                </div>

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.epayment">
                    Ingatkan pada
                </div>
                <div v-if="pageSetting.section.epayment">
                    <SOCardReminder
                        v-for="(data, idx) in reminderInfo.data_reminder_emoney"
                        :key="`${idx}-list-reminder-e-money`"
                        :title="reminderOption.filter((a) => a.id === data.idcountdown_master)[0].nama"
                        @change="validateAccess(activePeriodReminderUpdate) && showModal('epayment', 'edit', data.id)"
                        @delete="validateAccess(activePeriodReminderUpdate) && showDeleteModal('emoney', data.id)"
                    />
                </div>

                <div v-if="pageSetting.section.epayment" class="d-flex p-t-8" @click="validateAccess(activePeriodReminderUpdate) && showModal('epayment', 'create')">
                    <img src="@/assets/icons/plus-blue.svg" alt="" />
                    <div class="f-regular f-16 f-c-blue p-l-8">Tambah Pengingat</div>
                </div>
            </div>
            <!-- masa aktif poin -->
            <div class="p-x-20 p-y-20">
                <SOInputOnOff
                    class="m-d-20"
                    :checkboxes="masaAktifPoin"
                    :checked="pageSetting.section.masaAktifPoin"
                    @selected="switchMasaAktif"
                />

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.masaAktifPoin">
                    Perangkat yang digunakan
                </div>
                <div @click="showModalPerangkat('poin', reminderInfo.iddevice_reminder_poin)">
                    <SOSlotCard
                        v-if="pageSetting.section.masaAktifPoin"
                        :card-type="'box'"
                        :dropdown-menu="'none'"
                        class="p-d-8 m-d-16"
                    >
                        <template v-slot:card_head>
                            <div class="top-card">
                                <div class="f-regular f-16 f-c-black nomore" style="width: 250px">
                                    {{ devicePoin }}
                                </div>
                                <img src="@/assets/icon-sidebar/chevron-down.svg" alt="" />
                            </div>
                        </template>
                        <template v-slot:card_body>
                            <div class="f-regular f-14 f-c-midgrey">
                                {{ numberPoin }}
                            </div>
                        </template>
                    </SOSlotCard>
                </div>

                <div class="f-regular f-14 f-c-midgrey m-d-4" v-if="pageSetting.section.masaAktifPoin">
                    Ingatkan pada
                </div>
                <div v-if="pageSetting.section.masaAktifPoin">
                    <SOCardReminder
                        v-for="(data, idx) in reminderInfo.data_reminder_poin"
                        :key="`${idx}-list-reminder-e-money`"
                        :title="reminderOption.filter((a) => a.id === data.idcountdown_master)[0].nama"
                        @change="showModal('poin', 'edit', data.id, data.idcountdown_master)"
                        @delete="showDeleteModal('poin', data.id)"
                    />
                </div>

                <div v-if="pageSetting.section.masaAktifPoin" class="d-flex p-t-8" @click="showModal('poin', 'create')">
                    <img src="@/assets/icons/plus-blue.svg" alt="" />
                    <div class="f-regular f-16 f-c-blue p-l-8">Tambah Pengingat</div>
                </div>
            </div>
        </template>

        <template v-slot:modal>
            <ReminderMasaAktifModal
                v-if="pageSetting.modal.show"
                :get-data-action="pageSetting.modal.props.getDataAction"
                :submit-action="pageSetting.modal.props.submitAction"
                :reminder-id="pageSetting.modal.props.reminderId"
                :reminder-type="pageSetting.modal.props.reminderType"
                :reminder-action="pageSetting.modal.props.reminderAction"
                @close="closeModal"
                :idcountdown-master="pageSetting.modal.props.idcountdown_master"
            />
            <HapusReminderModal
                v-if="pageSetting.modal.delete"
                :reminder-id="pageSetting.modal.props.reminderId"
                :reminder-type="pageSetting.modal.props.reminderType"
                @close="closeModal"
            />
            <PilihPerangkatModal
                v-if="pageSetting.modal.perangkat"
                :selected-wa-device="pageSetting.modal.props.iddevice"
                :reminder-type="pageSetting.modal.props.reminderType"
                @close="closeModal"
            />
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "@/modules/wa-blast/store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";
import ReminderMasaAktifModal from "@/modules/pengaturan-umum/views/modal/ReminderMasaAktifModal.vue";
import HapusReminderModal from "@/modules/pengaturan-umum/views/modal/HapusReminderModal";
import PilihPerangkatModal from "@/modules/pengaturan-umum/views/modal/PilihPerangkatModal.vue";
import SOCardReminder from '../components/SOCardReminder.vue';
const activePeriodReminderUpdate = "activePeriodReminder.update";
export default {
    name: "ReminderMasaAktif",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOInputOnOff,
        SOSlotCard,
        ReminderMasaAktifModal,
        HapusReminderModal,
        PilihPerangkatModal,
        SOCardReminder,
    },
    computed: {
        activePeriodReminderUpdate() {
            return activePeriodReminderUpdate;
        },
        ...mapGetters("pengaturanUmumModule", {
            reminderInfo: "reminderInfo",
            reminderOption: "reminderOption",
        }),
        ...mapGetters(moduleName, {
            waDevice: "waDevice",
        }),
        deviceDeposit() {
            if (this.reminderInfo.iddevice_reminder_deposit === null) {
                return "WA Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_deposit);
            if (selected.length > 0) {
                return selected[0].nama;
            } else {
                return "WA Smartlink";
            }
        },
        numberDeposit() {
            if (this.reminderInfo.iddevice_reminder_deposit === null) {
                return "Nomor WA bawaan dari Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_deposit);
            if (selected.length > 0) {
                return selected[0].country_code + selected[0].number;
            } else {
                return "Nomor WA bawaan dari Smartlink";
            }
        },
        deviceEpayment() {
            if (this.reminderInfo.iddevice_reminder_emoney === null) {
                return "WA Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_emoney);
            if (selected.length > 0) {
                return selected[0].nama;
            } else {
                return "WA Smartlink";
            }
        },
        devicePoin() {
            if (this.reminderInfo.iddevice_reminder_poin === null) {
                return "WA Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_poin);
            if (selected.length > 0) {
                return selected[0].nama;
            } else {
                return "WA Smartlink";
            }
        },
        numberEpayment() {
            if (this.reminderInfo.iddevice_reminder_emoney === null) {
                return "Nomor WA bawaan dari Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_emoney);
            if (selected.length > 0) {
                return selected[0].country_code + selected[0].number;
            } else {
                return "Nomor WA bawaan dari Smartlink";
            }
        },
        numberPoin() {
            if (this.reminderInfo.iddevice_reminder_poin === null) {
                return "Nomor WA bawaan dari Smartlink";
            }
            let selected = this.waDevice.filter((v) => v.iddevice === this.reminderInfo.iddevice_reminder_poin);
            if (selected.length > 0) {
                return selected[0].country_code + selected[0].number;
            } else {
                return "Nomor WA bawaan dari Smartlink";
            }
        },
    },
    data() {
        return {
            paketDeposit: {
                name: "paket-kedaluarsa",
                data: [
                    {
                        id: "rem-1",
                        value: "1",
                        title: "Masa Aktif Paket Deposit",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            paketEpayment: {
                name: "paket-kedaluarsa",
                data: [
                    {
                        id: "rem-2",
                        value: "1",
                        title: "Masa Aktif Paket E-payment",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            masaAktifPoin: {
                name: "paket-poin",
                data: [
                    {
                        id: "rem-3",
                        value: "1",
                        title: "Masa Aktif Poin",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            pageSetting: {
                loading: false,
                section: {
                    deposit: false,
                    epayment: false,
                    masaAktifPoin: false,
                },
                modal: {
                    show: false,
                    delete: false,
                    perangkat: false,
                    props: {
                        getDataAction: "",
                        submitAction: "",
                        reminderId: "",
                        reminderType: "",
                        reminderAction: "",
                        iddevice: "",
                        idcountdown_master: "",
                    },
                },
            },
        };
    },
    mounted() {
        this.getInfo();
        this.fetchWaDevice();
    },
    methods: {
        ...mapActions("pengaturanUmumModule", {
            getOptions: "getReminderOption",
            switchMasaAktivPoin: "switchMasaAktivPoin",
            
        }),
        ...mapActions({
            fetchWaDevice: `${moduleName}/fetchWaDevice`,
        }),
        back() {
            this.$router.push({ name: "pengaturanUmum.dashboard" });
        },
        async getInfo() {
            this.pageSetting.loading = true;
            await this.getOptions();
            const res = await this.$store.dispatch("pengaturanUmumModule/getReminderInfo");
            if (!res.success) {
                this.$toast.error(res.err);
                return;
            }
            this.pageSetting.section.deposit = this.reminderInfo.active_reminder_deposit === 1;
            this.pageSetting.section.epayment = this.reminderInfo.active_reminder_emoney === 1;
            this.pageSetting.section.masaAktifPoin = this.reminderInfo.active_reminder_poin === 1;
            this.pageSetting.loading = false;

            setTimeout(() => {
                $(".card-body").addClass("card-body-no-footer");
            }, 100);
        },
        async onoffDeposit(val) {
            this.pageSetting.section.deposit = val;
            const res = await this.onoffReminder();
            if (!res.success) {
                this.$toast.error(res.err);
                this.pageSetting.section.deposit = !val;
                return;
            }
            await this.getInfo();
            this.$toast.success(res.msg);
        },
        async onoffEpayment(val) {
            this.pageSetting.section.epayment = val;
            const res = await this.onoffReminder();
            if (!res.success) {
                this.$toast.error(res.err);
                this.pageSetting.section.epayment = !val;
                return;
            }
            await this.getInfo();
            this.$toast.success(res.msg);
        },
        async switchMasaAktif(val) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            this.pageSetting.loading = true
            const res = await this.switchMasaAktivPoin(val);
            if (!res.success) {
                this.$toast.error(res.err);
                this.pageSetting.section.masaAktifPoin = !val;
                return;
            }
            await new Promise((resolve) => setTimeout(resolve, 300));
            await this.getInfo();
            this.$toast.success('Berhasil menyimpan pengaturan masa aktif');
        },
        async onoffReminder() {
            if (this.pageSetting.loading) {
                return;
            }
            let form = new FormData();
            form.append("enable_reminder_deposit", this.pageSetting.section.deposit ? "1" : "0");
            form.append("enable_reminder_emoney", this.pageSetting.section.epayment ? "1" : "0");
            return await this.$store.dispatch("pengaturanUmumModule/reminderSetting", form);
        },
        showModal(type, action, id = "", idcountdown_master) {
            switch (type) {
                case "deposit":
                    this.pageSetting.modal.show = true;
                    this.pageSetting.modal.props.reminderAction = action;
                    this.pageSetting.modal.props.reminderType = "deposit";
                    if (action === "create") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/createReminderDeposit";
                    } else if (action === "edit") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/updateReminder";
                        this.pageSetting.modal.props.getDataAction = "pengaturanUmumModule/getDetailReminder";
                        this.pageSetting.modal.props.reminderId = id.toString();
                        this.pageSetting.modal.props.reminderType = "deposit";
                    }
                    break;
                case "epayment":
                    this.pageSetting.modal.show = true;
                    this.pageSetting.modal.props.reminderAction = action;
                    this.pageSetting.modal.props.reminderType = "emoney";
                    if (action === "create") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/createReminderEpayment";
                    } else if (action === "edit") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/updateReminder";
                        this.pageSetting.modal.props.getDataAction = "pengaturanUmumModule/getDetailReminder";
                        this.pageSetting.modal.props.reminderId = id.toString();
                        this.pageSetting.modal.props.reminderType = "emoney";
                    }
                    break;
                case "poin":
                    this.pageSetting.modal.show = true;
                    this.pageSetting.modal.props.reminderAction = action;
                    this.pageSetting.modal.props.reminderType = "poin";
                    if (action === "create") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/createReminderPoin";
                    } else if (action === "edit") {
                        this.pageSetting.modal.props.submitAction = "pengaturanUmumModule/updateReminderPoin";
                        this.pageSetting.modal.props.getDataAction = "pengaturanUmumModule/getDetailReminder";
                        this.pageSetting.modal.props.reminderId = id.toString();
                        this.pageSetting.modal.props.reminderType = "poin";
                        this.pageSetting.modal.props.idcountdown_master = idcountdown_master;
                    }
                    break;
                default:
                    break;
            }
            
        },
        showDeleteModal(type, id) {
            this.pageSetting.modal.delete = true;
            this.pageSetting.modal.props.reminderId = id.toString();
            this.pageSetting.modal.props.reminderType = type;
        },
        showModalPerangkat(type, iddevice) {
            if (iddevice === null) iddevice = "";
            this.pageSetting.modal.perangkat = true;
            this.pageSetting.modal.props.reminderType = type;
            this.pageSetting.modal.props.iddevice = iddevice;
        },
        closeModal() {
            this.pageSetting.modal = {
                show: false,
                delete: false,
                perangkat: false,
                props: {
                    getDataAction: "",
                    submitAction: "",
                    reminderId: "",
                    reminderType: "",
                    iddevice: "",
                },
            };
        },
    },
    beforeDestroy() {
        $(".card-body").removeClass("card-body-no-footer");
    },
};
</script>

<style>
.card-body-no-footer {
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
</style>
